import * as React from "react";
import "./spot-button.scss";
import { Spinner } from "./basic/spinner/Spinner";

export interface ButtonProps {
    id?: string;
    /**
     * Is this the principal call to action on the page?
     */
    type?: "primary" | "secondary" | "tertiary" | "ghost";
    /**
     * What background color to use
     */
    backgroundColor?: string;
    /**
     * Button contents
     */
    label: string;
    /**
     * Optional click handler
     */
    onClick?: () => any;

    isLoading?: boolean;

    disabled?: boolean;
    dataTest?: string;
    /**
     * name of the icon i.e. the icon className
     */
    iconClassName?: string;
}

/**
 * Primary UI component for user interaction
 */
export const SPOTButton = ({ type = "secondary", backgroundColor, label, ...props }: ButtonProps) => {
    const iconClassName = props.iconClassName ? props.iconClassName : "";

    return (
        <button
            {...props}
            id={props.id}
            data-test={props.dataTest}
            type="button"
            className={["spot-button", "spot-button--" + type].join(" ")}
            style={{ backgroundColor }}
            disabled={props.disabled}>
            {props.iconClassName && <i className={iconClassName} />}

            {props.isLoading && (
                <div className={"loading"}>
                    <Spinner isLoading={props.isLoading} color={"white"} size={18} />
                </div>
            )}

            {label}
        </button>
    );
};
